<label>
    <app-regular-input [icon]="icon" [(input)]="input" (onChange)="onChangeInput($event)"></app-regular-input>
    <input type="color" [(ngModel)]="input" (ngModelChange)="onChangeInput($event)" />
</label>
